let Color=[
    {
        bg:"#F29F75",
        bgcolor:"#61402F"
    },
    {
        bg:"#FAAFA9",
        bgcolor:"#644743"
    },
    {
        bg:"#E2f6d3",
        bgcolor:"#5A6253"
    },
    {
        bg:"#B4DED4",
        bgcolor:"#485855"
    },
    {
        bg:"#D3BFDB",
        bgcolor:"#544C59"
    },
    {
        bg:"#FFF8B9",
        bgcolor:"#67634A"
    },
    {
        bg:"#AFCCDC",
        bgcolor:"#475258"
    }
];
export default Color;
            // <div className="color-picker">
            //   <div className="head">
            //     <p>colors</p>
            //     <div className="pull">
            //       <KeyboardArrowDownOutlinedIcon className='bttn' onClick={(e)=>{
            //         e.preventDefault();
            //         let tpp1 = document.querySelector(".color-picker");
            //         let note = temp1.current;
            //         note.style.backgroundColor=final.bg;
            //         tpp1.style.backgroundColor=final.bg;

            //         setcolor(false);
            //       }} />
            //     </div>
            //   </div>
            //   <div className="colors">
            //     <div className="b1">
            //     <div className="box" id='bt1' onClick={(e)=>{
            //       e.preventDefault();
            //       if(col[1]!==true){
            //         col[1]=true;
            //         var tt = [...col];
            //         for(var i=1;i<8;i++){
            //           if(i!==1){
            //             tt[i]=false;
            //           }
            //         }
            //         setcol(tt);
            //       }
            //      let tpp = document.querySelector("#bt1");
            //      tpp.style.border="1.3px solid #1A54B8";
            //      let tpp1 = document.querySelector(".color-picker");
            //      let note = temp1.current;
            //      note.style.backgroundColor="#666666";
            //      tpp1.style.backgroundColor="#EFF4FA";
            //      setfinal({bg:"white" , bgcolor:"#666666"});
            //  for( i =1;i<=8;i++){
            //   if(i!==1){
            //     const tp =`${i}`;
            //     const tppp = document.querySelector("#bt"+(tp));
            //     tppp.style.border="1.3px solid black";
            //  }
            //  }
            //     }} style={{backgroundColor:"white"}} >
            //         {col[1]===true &&(
            //           <DoneOutlinedIcon className='bttn' />
            //         )}
            //         {col[1]===false &&(
            //           <FormatColorResetOutlinedIcon className='bique'/>
            //         )}
            //     </div>

            //     <div className="box" id='bt2' onClick={(e)=>{
            //       e.preventDefault();
            //       if(col[2]!==true){
            //         col[2]=true;
            //         var tt = [...col];
            //         for( var i=1;i<=8;i++){
            //           if(i!==2){
            //             tt[i]=false;
            //           }
            //         }
            //         setcol(tt);
            //       }
            //       let tpp = document.querySelector("#bt2");
            //       let tpp1 = document.querySelector(".color-picker");
            //       let note = temp1.current;
            //       // note.style.backgroundColor="color-mix(in srgb ,#666666, #F29F75)";
            //       note.style.backgroundColor="#61402F";
            //       tpp1.style.backgroundColor="#F29F75";
            //       tpp.style.border="1.3px solid #1A54B8";
            //       setfinal({bg:"#F29F75" , bgcolor:"#61402F"});
            //       for(i =1;i<=8;i++){
            //        if(i!==2){
            //         const tee="#bt";
            //         const val = (tee)+(i);
            //          const tppp = document.querySelector(val);
            //          console.log(tppp);
            //          tppp.style.border="1.3px solid black";
            //       }
            //      }
            //     }} style={{backgroundColor:"#F29F75"}} >
            //         {col[2]===true &&(
            //           <DoneOutlinedIcon className='bttn'/>
            //         )}
            //     </div>

            //     <div className="box" id='bt3' onClick={(e)=>{
            //       e.preventDefault();
            //       if(col[3]!==true){
            //         col[3]=true;
            //         var tt = [...col];
            //         for(var i=1;i<=8;i++){
            //           if(i!==3){
            //             tt[i]=false;
            //           }
            //         }
            //         setcol(tt);
            //       }
            //       let tpp = document.querySelector("#bt3");
            //       tpp.style.border="2px solid #1A54B8";
            //       let tpp1 = document.querySelector(".color-picker");
            //       let note = temp1.current;
            //       note.style.backgroundColor="#644743";
            //       tpp1.style.backgroundColor="#FAAFA9";
            //       setfinal({bg:"#FAAFA9" , bgcolor:"#644743"});
            //       for( i =1;i<=8;i++){
            //        if(i!==3){
            //          const tp =`${i}`;
            //          const tppp = document.querySelector("#bt"+(tp));
            //          tppp.style.border="1.3px solid black";
            //       }
            //      }
            //     }} style={{backgroundColor:"#FAAFA9"}} >
            //         {col[3]===true &&(
            //           <DoneOutlinedIcon className='bttn'/>
            //         )}
            //     </div>

            //     <div className="box" id='bt4' onClick={(e)=>{
            //       e.preventDefault();
            //       if(col[4]!==true){
            //         col[4]=true;
            //         var tt = [...col];
            //         for(var i=1;i<=8;i++){
            //           if(i!==4){
            //             tt[i]=false;
            //           }
            //         }
            //         setcol(tt);
            //       }
            //       let tpp = document.querySelector("#bt4");
            //       tpp.style.border="1.3px solid #1A54B8";
            //       let tpp1 = document.querySelector(".color-picker");
            //       let note = temp1.current;
            //       note.style.backgroundColor="#625A58";
            //       tpp1.style.backgroundColor="#F5E2DC";
            //       setfinal({bg:"#F5E2DC" , bgcolor:"#625A58"});
            //       for( i =1;i<=8;i++){
            //        if(i!==4){
            //          const tp =`${i}`;
            //          const tppp = document.querySelector("#bt"+(tp));
            //          tppp.style.border="2px solid black";
            //       }
            //      }
            //     }} style={{backgroundColor:"#F5E2DC"}} >
            //         {col[4]===true &&(
            //           <DoneOutlinedIcon className='bttn'/>
            //         )}
            //     </div>
            //     </div>

            //     <div className="b1">
            //     <div className="box" id='bt5' onClick={(e)=>{
            //       e.preventDefault();
            //       if(col[5]!==true){
            //         col[5]=true;
            //         var tt = [...col];
            //         for(var i=1;i<=8;i++){
            //           if(i!==5){
            //             tt[i]=false;
            //           }
            //         }
            //         setcol(tt);
            //       }
            //       let tpp = document.querySelector("#bt5");
            //       tpp.style.border="1.3px solid #1A54B8";
            //       let tpp1 = document.querySelector(".color-picker");
            //       let note = temp1.current;
            //       note.style.backgroundColor="#485855";
            //       tpp1.style.backgroundColor="#B4DED4";
            //       setfinal({bg:"#B4DED4" , bgcolor:"#485855"});
            //       for( i =1;i<=8;i++){
            //        if(i!==5){
            //          const tp =`${i}`;
            //          const tppp = document.querySelector("#bt"+(tp));
            //          tppp.style.border="1.3px solid black";
            //       }
            //      }
            //     }} style={{backgroundColor:"#B4DED4"}} >
            //         {col[5]===true &&(
            //           <DoneOutlinedIcon className='bttn'/>
            //         )}
            //     </div>

            //     <div className="box" id='bt6' onClick={(e)=>{
            //       e.preventDefault();
            //       if(col[6]!==true){
            //         col[6]=true;
            //         var tt = [...col];
            //         for(var i=1;i<=8;i++){
            //           if(i!==6){
            //             tt[i]=false;
            //           }
            //         }
            //         setcol(tt);
            //       }
            //       let tpp = document.querySelector("#bt6");
            //       tpp.style.border="1.3px solid #1A54B8";
            //       let tpp1 = document.querySelector(".color-picker");
            //       let note = temp1.current;
            //       note.style.backgroundColor="#544C59";
            //       tpp1.style.backgroundColor="#D3BFDB";
            //       setfinal({bg:"#D3BFDB" , bgcolor:"#544C59"});
            //       for( i =1;i<=8;i++){
            //        if(i!==6){
            //          const tp =`${i}`;
            //          const tppp = document.querySelector("#bt"+(tp));
            //          tppp.style.border="1.3px solid black";
            //       }
            //      }
            //     }} style={{backgroundColor:"#D3BFDB"}} >
            //         {col[6]===true &&(
            //           <DoneOutlinedIcon className='bttn'/>
            //         )}
            //     </div>

            //     <div className="box" id='bt7' onClick={(e)=>{
            //       e.preventDefault();
            //       if(col[7]!==true){
            //         col[7]=true;
            //         var tt = [...col];
            //         for(var i=1;i<=8;i++){
            //           if(i!==7){
            //             tt[i]=false;
            //           }
            //         }
            //         setcol(tt);
            //       }
            //       let tpp = document.querySelector("#bt7");
            //       tpp.style.border="1.3px solid #1A54B8";
            //       let tpp1 = document.querySelector(".color-picker");
            //       let note = temp1.current;
            //       note.style.backgroundColor="#67634A";
            //       tpp1.style.backgroundColor="#FFF8B9";
            //       setfinal({bg:"#FFF8B9" , bgcolor:"#67634A"});
            //       for( i =1;i<=8;i++){
            //        if(i!==7){
            //          const tp =`${i}`;
            //          const tppp = document.querySelector("#bt"+(tp));
            //          tppp.style.border="1.3px solid black";
            //       }
            //      }
            //     }} style={{backgroundColor:"#FFF8B9"}} >
            //         {col[7]===true &&(
            //           <DoneOutlinedIcon className='bttn'/>
            //         )}
            //     </div>

            //     <div className="box" id='bt8' onClick={(e)=>{
            //       e.preventDefault();
            //       if(col[8]!==true){
            //         col[8]=true;
            //         var tt = [...col];
            //         for(var i=1;i<8;i++){
            //           if(i!==8){
            //             tt[i]=false;
            //           }
            //         }
            //         setcol(tt);
            //       }
            //       let tpp = document.querySelector("#bt8");
            //       tpp.style.border="1.3px solid #1A54B8";
            //       let tpp1 = document.querySelector(".color-picker");
            //       let note = temp1.current;
            //       note.style.backgroundColor="#475258";
            //       tpp1.style.backgroundColor="#AFCCDC";
            //       setfinal({bg:"#AFCCDC" , bgcolor:"#475258"});
            //       for( i =1;i<=8;i++){
            //        if(i!==8){
            //          const tp =`${i}`;
            //          const tppp = document.querySelector("#bt"+(tp));
            //          tppp.style.border="1.3px solid black";
            //       }
            //      }
            //     }} style={{backgroundColor:"#AFCCDC"}} >
            //         {col[8]===true &&(
            //           <DoneOutlinedIcon className='bttn'/>
            //         )}
            //     </div>
            //     </div>
            //   </div>
            //   </div>